import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import moment from 'moment'

import { openExternalBrowserWithAuth } from 'helpers/web_to_client'

import { Info, ScrollArea } from 'react-wot-bootstrap'

import FamePoints from 'components/FamePoints/FamePoints'

import WGCWXShopHeaderCard from './components/WGCWXShopCard/WGCWXShopHeaderCard'
import WGCWXShopProductGrid from './components/WGCWXShopProductGrid/WGCWXShopProductGrid'

import {
    GLOBAL_MAP_EVENT_NAME,
    GO_TO_GLOBAL_MAP,
    PERSONAL_BONUSES,
    PERSONAL_FAME_POINTS,
    PERSONAL_FAME_POINTS_BONUS,
    PURCHASE_DATETIME_END,
} from './translations'
import {
    ProductPropTypes,
    RewardPropTypes,
    RewardsMetaPropTypes,
} from 'containers/WGCWXShop/propTypes'

import styles from './WGCWXShopProducts.scss'

class WGCWXShopProducts extends React.Component {
    static propTypes = {
        products: PropTypes.objectOf(ProductPropTypes),
        accountInfo: PropTypes.shape({
            fame_points: PropTypes.number,
            fame_points_bonus: PropTypes.number,
        }).isRequired,
        rewards: PropTypes.arrayOf(RewardPropTypes),
        rewardsMeta: RewardsMetaPropTypes,
        eventName: PropTypes.string.isRequired,
        globalMapUrl: PropTypes.string.isRequired,
        signInTokenUrl: PropTypes.string.isRequired,

        selectProduct: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            scrollableAreaHeight: 0,
        }

        this.BOTTOM_SCROLL_OFFSET = 10
        this.SCROLL_STEP = 50
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize)

        this.setScrollAreaHeight()
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize)
    }

    handleResize = () => {
        this.setScrollAreaHeight()
    }

    setScrollAreaHeight() {
        if (!this._body) return
        const coords = this._body.getBoundingClientRect()
        const height = window.innerHeight - coords.top - this.BOTTOM_SCROLL_OFFSET
        this.setState({ scrollableAreaHeight: height })
    }

    openGlobalMap = e => {
        e.preventDefault()
        openExternalBrowserWithAuth(this.props.signInTokenUrl, this.props.globalMapUrl)
    }

    renderHeader(rewardsAvailableToBuy) {
        const { fame_points_bonus, fame_points } = this.props.accountInfo

        if (fame_points === undefined) return null

        const userPfpValue = (
            <span className={styles.subtitle_value}>
                <FamePoints
                    value={fame_points}
                    iconPosition="before"
                    mixClassName={styles.subtitle_value}
                />
            </span>
        )

        return (
            <WGCWXShopHeaderCard>
                <span className={styles.subtitle}>
                    {PERSONAL_FAME_POINTS(userPfpValue)}
                </span>
                {(!rewardsAvailableToBuy && fame_points_bonus !== undefined) &&
                    <span className={styles.subtitle}>
                        {PERSONAL_FAME_POINTS_BONUS(
                            <span className={styles.subtitle_value}>
                                {`+${fame_points_bonus}%`}
                            </span>
                        )}
                    </span>
                }
            </WGCWXShopHeaderCard>
        )
    }

    render() {
        const rewardsAvailableToBuy = (
            this.props.rewards &&
            this.props.rewards.every(reward => reward.price > 0)
        )
        const datetimeEnd = moment.utc(this.props.rewardsMeta.purchaseDatetimeEnd).local()

        return (
            <div className={styles.base}>
                <div className={styles.content}>
                    <h1 className={styles.title}>
                        {PERSONAL_BONUSES}
                    </h1>
                    <p className={styles.eventInfo}>
                        {GLOBAL_MAP_EVENT_NAME(this.props.eventName)}
                        &nbsp;
                        <a href="" className={styles.wgcwxLink} onClick={this.openGlobalMap}>
                            {GO_TO_GLOBAL_MAP}
                        </a>
                    </p>
                    {
                        rewardsAvailableToBuy &&
                        <div className={classNames(styles.info, styles.info__center)}>
                            <Info />
                            &nbsp;
                            {PURCHASE_DATETIME_END(datetimeEnd)}
                        </div>
                    }
                    <div className={styles.header}>
                        {this.renderHeader(rewardsAvailableToBuy)}
                    </div>
                    <div className={styles.separator} />
                    <div ref={c => this._body = c} className={styles.body}>
                        <ScrollArea
                            stepHeight={this.SCROLL_STEP}
                            scrollableAreaHeight={this.state.scrollableAreaHeight}
                        >
                            <WGCWXShopProductGrid
                                products={this.props.products}
                                accountFamePoints={this.props.accountInfo.fame_points}
                                selectProduct={this.props.selectProduct}
                            />
                        </ScrollArea>
                    </div>
                </div>
            </div>
        )
    }
}

export default WGCWXShopProducts



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXShopProducts/WGCWXShopProducts.jsx